export const ballisticDefaults={angle:27,speed:14,gravity:9.8,drag:.45,turn:120,moving:true};
export const ballisticModes=['hitscan','projectile','drag','homing'];
export const ballisticDuration=3;
export const ballisticTarget=(t,moving=true)=>({x:9,y:2.4+(moving?Math.sin(t*1.7)*1.05:0)});
const clamp=(v,a,b)=>Math.max(a,Math.min(b,v));
export function segmentCircleEntry(a,b,center,radius){
 const x=a.x-center.x,y=a.y-center.y,dx=b.x-a.x,dy=b.y-a.y,c=x*x+y*y-radius*radius;
 if(c<=0)return 0;const aa=dx*dx+dy*dy;if(aa<1e-16)return null;const bb=2*(x*dx+y*dy),d=bb*bb-4*aa*c;if(d<0)return null;
 const root=(-bb-Math.sqrt(d))/(2*aa);return root>=0&&root<=1?root:null;
}
function segmentDistance(a,b){const dx=b.x-a.x,dy=b.y-a.y,length=dx*dx+dy*dy,u=length?clamp(-(a.x*dx+a.y*dy)/length,0,1):0;return Math.hypot(a.x+u*dx,a.y+u*dy);}
export function simulateBallistic(mode,parameters={}){
 const o={...ballisticDefaults,...parameters},angle=o.angle*Math.PI/180,start={x:0,y:1.3,t:0},points=[start],targetRadius=.36,radius=mode==='hitscan'?targetRadius:targetRadius+.055;
 let x=0,y=start.y,vx=Math.cos(angle)*o.speed,vy=Math.sin(angle)*o.speed,heading=angle,t=0,closestMiss=Infinity,hit=false,hitTime=null;
 if(mode==='hitscan'){
  const end={x:Math.cos(angle)*18,y:start.y+Math.sin(angle)*18},target=ballisticTarget(0,o.moving),entry=segmentCircleEntry(start,end,target,radius);
  closestMiss=Math.max(0,segmentDistance({x:start.x-target.x,y:start.y-target.y},{x:end.x-target.x,y:end.y-target.y})-radius);
  hit=entry!==null;hitTime=hit?0:null;points.push({x:start.x+(end.x-start.x)*(entry??1),y:start.y+(end.y-start.y)*(entry??1),t:0});
  return {mode,points,hit,hitTime,closestMiss,duration:0};
 }
 const dt=1/240;
 for(let i=0;i<ballisticDuration/dt;i++){
  const previous={x,y,t},before=ballisticTarget(t,o.moving);
  if(mode==='homing'){
   const desired=Math.atan2(before.y-y,before.x-x),error=Math.atan2(Math.sin(desired-heading),Math.cos(desired-heading)),limit=o.turn*Math.PI/180*dt;
   heading+=clamp(error,-limit,limit);vx=Math.cos(heading)*o.speed;vy=Math.sin(heading)*o.speed;x+=vx*dt;y+=vy*dt;
  }else if(mode==='drag'&&o.drag>1e-8){
   const k=o.drag,decay=Math.exp(-k*dt),integral=(1-decay)/k;x+=vx*integral;y+=(vy+o.gravity/k)*integral-o.gravity/k*dt;vx*=decay;vy=(vy+o.gravity/k)*decay-o.gravity/k;
  }else{x+=vx*dt;y+=vy*dt-o.gravity*dt*dt*.5;vy-=o.gravity*dt;}
  t+=dt;const after=ballisticTarget(t,o.moving),a={x:previous.x-before.x,y:previous.y-before.y},b={x:x-after.x,y:y-after.y};closestMiss=Math.min(closestMiss,Math.max(0,segmentDistance(a,b)-radius));
  const entry=segmentCircleEntry(a,b,{x:0,y:0},radius);
  if(entry!==null){hit=true;hitTime=previous.t+dt*entry;points.push({x:previous.x+(x-previous.x)*entry,y:previous.y+(y-previous.y)*entry,t:hitTime});closestMiss=0;break;}
  if(y<=0){const u=previous.y/(previous.y-y);points.push({x:previous.x+(x-previous.x)*u,y:0,t:previous.t+dt*u});break;}
  points.push({x,y,t});if(x>14||x< -1||y>8)break;
 }
 return {mode,points,hit,hitTime,closestMiss,duration:points.at(-1).t};
}
export function sampleBallistic(result,time){
 const points=result.points;if(time<=0)return points[0];if(time>=result.duration)return points.at(-1);
 let lo=0,hi=points.length-1;while(hi-lo>1){const mid=(lo+hi)>>1;if(points[mid].t<=time)lo=mid;else hi=mid;}
 const a=points[lo],b=points[hi],u=(time-a.t)/(b.t-a.t);return {x:a.x+(b.x-a.x)*u,y:a.y+(b.y-a.y)*u,t:time};
}
